// Declared twice so that docs appear when selecting colors
export interface PhosphatePalette extends Record<string, string> {
  /** **#E2F3F8** Blue */
  readonly phosphate10: string;
  /** **#C3E5F1** Blue */
  readonly phosphate30: string;
  /** **#88CDE3** Blue */
  readonly phosphate60: string;
  /** **#39ABD1** Blue */
  readonly phosphatePrimary: string;
  /** **#0E81A7** Blue */
  readonly phosphate80: string;
  /** **#0B5973** Blue */
  readonly phosphate90: string;
}

export const phosphatePalette: PhosphatePalette = {
  phosphate10: '#E2F3F8',
  phosphate30: '#C3E5F1',
  phosphate60: '#88CDE3',
  phosphatePrimary: '#39ABD1',
  phosphate80: '#0E81A7',
  phosphate90: '#0B5973',
};
